export default __webpack_public_path__ + "static/media/NotoSans-Bold.cc72672b.woff";